import React, { useState, useEffect } from 'react'
import '../merchant/merchant.css'
import { Grid } from '@mui/material'
import { LocalForm, Control, Form } from 'react-redux-form'
import Errors from '../../components/common/errors'
import { Row, Col, FormGroup, Label } from 'reactstrap'
import {
    zipcodeFieldLength,
    merchantNameField,
    streetField,
    zipcodeField,
    cityField,
    streetValid,
    cityValid,
    merchantValid,
} from '../../utilities/message'
import Match from '../../utilities/validation'
import dayjs from 'dayjs'

import { useDispatch, useSelector } from 'react-redux'
import {
    getMerchantProfile,
    editMerchant,
} from '../../actions/merchant'

import Loader from '../../components/Loader'
import 'moment-timezone'

const MerchantProfile = ({ history }) => {
    const [openModal, setModal] = useState(false)
    const dispatch = useDispatch()
    const merchant = useSelector((state) => state.merchant)
    const user = useSelector((state) => state.user)
    const merchantData = useSelector((state) => state.merchantProfile)
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [duration, setDuration] = useState(0)
    const [search, setSearch] = useState('')
    const loaders = useSelector((state) => state.loader)
    const [edit, setEdit] = useState(false)
    const [editData, setEditData] = useState([])
    const [files, setFile] = useState(null)
    const [opendrag, setOpen] = useState()
    const [imageUrl, setImageUrl] = useState(null)
    const [error, setError] = useState('')
    const [imgerror, setImgError] = useState(false)
    const [uploadClicked, setUploadClicked] = useState(false)
    const [dragActive, setDragActive] = React.useState(false)
    const inputRef = React.useRef(null)

    const [isChanged, setIsChanged] = useState(false)

    const handleDrag = function (e) {
        e.preventDefault()
        e.stopPropagation()
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true)
        } else if (e.type === 'dragleave') {
            setDragActive(false)
        }
    }

    useEffect(() => {
        if (user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin) {
            history.push("/settings")
        }
    }, [])

    useEffect(() => {
        let params = {};
        params.merchant_id = user?.data?.merchantData.id;
        dispatch(getMerchantProfile(params, (res) => { }));
    }, [])

    const handleDrop = function (e) {
        e.preventDefault()
        e.stopPropagation()
        setDragActive(false)
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const MAX_FILE_SIZE = 5120 // 5MB

            const fileSizeKiloBytes = e.dataTransfer.files[0].size / 1024

            const allowedTypes = ['image/jpeg', 'image/png']
            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                setError('File size is greater than maximum limit')
                setImgError(true)
                return
            } else if (!allowedTypes.includes(e.dataTransfer.files[0]?.type)) {
                setError('Only JPEG, and PNG images are allowed.')
                setImgError(true)
                return
            } else {
                setError('')
                setImgError(false)
                getBase64(e.dataTransfer.files[0])
                    .then((result) => {
                        var file = result.split(',')
                        setFile(file[1])
                    })
                    .catch((err) => { })

                var reader = new FileReader()
                var url = reader.readAsDataURL(e.dataTransfer.files[0])

                reader.onloadend = function (e) {
                    setImgError(false)
                    setImageUrl(reader.result)
                }.bind(this)
            }
        }
    }

    const getBase64 = (file) => {
        return new Promise((resolve) => {
            let fileInfo
            let baseURL = ''
            let reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                baseURL = reader.result
                resolve(baseURL)
            }
        })
    }

    const handleChange = function (e) {
        setIsChanged(true)
        setUploadClicked(true)
        setImageUrl(null)
        setFile(null)
        e.preventDefault()
        if (e.target.files && e.target.files[0]) {
            const MAX_FILE_SIZE = 5120 // 5MB

            const fileSizeKiloBytes = e.target.files[0].size / 1024

            const allowedTypes = ['image/jpeg', 'image/png']
            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                setError('File size is greater than maximum limit')
                setImgError(true)
                return
            } else if (!allowedTypes.includes(e.target.files[0]?.type)) {
                setError('Only JPEG, and PNG images are allowed.')
                setImgError(true)
                return
            } else {
                setError('')
                setImgError(false)
                getBase64(e.target.files[0])
                    .then((result) => {
                        var file = result.split(',')
                        setFile(file[1])
                    })
                    .catch((err) => { })

                var reader = new FileReader()
                var url = reader.readAsDataURL(e.target.files[0])

                reader.onloadend = function (e) {
                    setImgError(false)
                    setImageUrl(reader.result)
                }.bind(this)
            }
        }
    }

    const onButtonClick = (e) => {
        e.preventDefault()
        inputRef.current.click()
        setIsChanged(true)
    }

    const editMerchantPopup = (data, e) => {
        e.preventDefault()
        e.stopPropagation()
        setImgError(false)
        setEdit(true)
        setEditData(data)
        setModal(true)
    }

    var newData = []
    useEffect(() => {
        newData = merchant.list.map((item, index) => {
            return [
                '',
                item.name,
                item.email,
                item.created_at,
                item.item_count,
                item.is_active,
                item.streetAddress,
                item.city,
                item.state,
                item.zip,
                item.merchant_image,
                item.id,
                item.created_by,
                item.updated_by
            ]
        })
        setTimeout(() => {
            setData(newData)
        }, 500)
    }, [merchant.list])

    const updateMerchant = (e) => {
        var data
        if (files == null) {
            data = { ...e, ...{ id: merchantData?.list?.id } }
        } else {
            data = { ...e, ...{ merchant_image: files, id: merchantData?.list?.id } }
        }
        dispatch(
            editMerchant(data, (res) => {
                if (res) {
                    const params = { page: page, limit: limit }
                    if (search != '' && search != null) {
                        params.search = search
                    }
                    if (duration != '' && duration != null) {
                        params.duration = duration
                    }
                    setFile(null)
                    let parameter = { merchant_id: merchantData?.list?.id }
                    dispatch(
                        getMerchantProfile(parameter, (res) => { }),
                    )
                    setIsChanged(false)
                }
            }),
        )
    }

    const updateValue = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1)
    }

    return (
        <div>
            <Loader loading={loaders.isFetching} />
            <div style={{ display: 'flex' }}>
                <div>
                    <p className="headinguser">Edit Profile</p>
                    <p className="subheadinggraph">Manage & Edit Your Profile</p>
                </div>
            </div>

            <div style={{ width: '600px' }}>
                <LocalForm
                    model="user"
                    onSubmit={(values) => updateMerchant(values)}
                // onChange={handleFormChange}
                >
                    <Row>
                        <FormGroup style={{ paddingBottom: '20px', paddingTop: '20px' }}>
                            <Label>Logo</Label>
                            <div className="imageinputfield">
                                <div id="form-file-upload" onDragEnter={handleDrag}>
                                    <input
                                        ref={inputRef}
                                        type="file"
                                        id="input-file-upload"
                                        onChange={handleChange}
                                    />
                                    <label
                                        id="label-file-upload"
                                        htmlFor="input-file-upload"
                                        className={dragActive ? 'drag-active' : ''}
                                    >
                                        <div style={{ textAlign: 'center' }}>
                                            <i
                                                class="icon  uploadiconnew"
                                                style={{
                                                    height: '100%',
                                                    width: '100%',
                                                }}
                                            >
                                                <img
                                                    style={{ marginTop: '20px' }}
                                                    src={require('../../assets/images/upload.png')}
                                                />
                                            </i>
                                            <p style={{ margin: '0px' }}>
                                                Drag and drop your file here or click to upload
                                            </p>
                                            <button
                                                className="upload-button"
                                                onClick={(e) => onButtonClick(e)}
                                                style={{ color: '#5c5454' }}
                                            >
                                                File Format: JPG Or PNG | 5MB file
                                                size limit
                                            </button>
                                        </div>
                                    </label>
                                    {dragActive && (
                                        <div
                                            id="drag-file-element"
                                            onDragEnter={handleDrag}
                                            onDragLeave={handleDrag}
                                            onDragOver={handleDrag}
                                            onDrop={handleDrop}
                                        ></div>
                                    )}
                                </div>
                            </div>

                            {!uploadClicked &&
                                <div
                                    style={{ textAlign: 'center', padding: '10px' }}
                                >
                                    <img
                                        crossorigin="anonymous"
                                        height={70}
                                        width={70}
                                        src={merchantData?.list?.merchant_image}
                                    />
                                </div>
                            }
                            {uploadClicked &&
                                <div
                                    style={{ textAlign: 'center', padding: '10px' }}
                                >
                                    <img
                                        crossorigin="anonymous"
                                        height={70}
                                        width={70}
                                        src={imageUrl}
                                    />
                                </div>
                            }
                            {imgerror && <p style={{ color: 'red' }}>{error}</p>}
                        </FormGroup>

                        <FormGroup>
                            <div style={{ display: 'flex', paddingBottom: '20px' }}>
                                <Control.text
                                    model="user.name"
                                    className="form-control nameField  input-field"
                                    id="user.username"
                                    defaultValue={merchantData?.list?.name}
                                    placeholder="Merchant Full Name"
                                    parser={(value) => updateValue(value)}
                                    errors={{
                                        merchantNameField: (val) => !val,
                                        merchantValid: (val) =>
                                            val && val.length < 2,
                                    }}
                                    onChange={() => { setIsChanged(true) }}
                                />
                            </div>
                            <Errors
                                model="user.name"
                                errors={{
                                    merchantNameField,
                                    merchantValid,
                                }}
                            />
                        </FormGroup>

                        <Col className="column" sm="12" md="12">
                            <FormGroup>
                                <div style={{ display: 'flex', paddingBottom: '20px' }}>
                                    <Control.text
                                        model="user.streetAddress"
                                        className="form-control nameField input-field"
                                        id="user.streetAddress"
                                        placeholder="Street Address"
                                        defaultValue={merchantData?.list?.streetAddress}
                                        errors={{
                                            streetField: (val) => !val,
                                            streetValid: (val) =>
                                                val &&
                                                !Match.isValidAlphaNumeric(val),
                                            streetValid: (val) =>
                                                val && val.length < 2,
                                        }}
                                        onChange={() => { setIsChanged(true) }}
                                    />
                                </div>
                                <Errors
                                    model="user.streetAddress"
                                    errors={{
                                        streetField,
                                        streetValid,
                                    }}
                                />
                            </FormGroup>
                        </Col>

                        <Col className="column" sm="12" md="12">
                            <FormGroup>
                                <div style={{ display: 'flex', paddingBottom: '20px' }}>
                                    <Control.text
                                        model="user.city"
                                        className="form-control nameField captilize input-field"
                                        id="user.city"
                                        placeholder="City"
                                        defaultValue={merchantData?.list?.city}
                                        errors={{
                                            cityField: (val) => !val,
                                            cityValid: (val) =>
                                                (val &&
                                                    !Match.isValidAlphabate(val)) ||
                                                (val && val.length < 2),
                                        }}
                                        onChange={() => { setIsChanged(true) }}
                                    />
                                </div>
                                <Errors
                                    model="user.city"
                                    errors={{
                                        cityField,
                                        cityValid,
                                    }}
                                />
                            </FormGroup>
                        </Col>

                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={6}>
                                <Col className="column" sm="12" md="6">
                                    <FormGroup>
                                        <div style={{ display: 'flex' }}>
                                            <Control.text
                                                model="user.state"
                                                className="form-control stateField input-field"
                                                id="user.state"
                                                placeholder="State"
                                                value="California"
                                                defaultValue="California"
                                                disabled={true}
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <Col className="column" sm="12" md="12">
                                    <FormGroup>
                                        <div style={{ display: 'flex' }}>
                                            <Control.text
                                                model="user.zip"
                                                className="form-control zipField input-field"
                                                id="user.zip"
                                                placeholder="Zip Code"
                                                maxLength={5}
                                                defaultValue={
                                                    merchantData?.list?.zip
                                                }
                                                type="number"
                                                errors={{
                                                    zipcodeField: (val) => !val,
                                                    zipcodeFieldLength: (val) =>
                                                        (val && val.length < 5) ||
                                                        (val && val.length > 5),
                                                }}
                                                onChange={() => { setIsChanged(true) }}
                                            />
                                        </div>
                                        <Errors
                                            model="user.zip"
                                            errors={{
                                                zipcodeField,
                                                zipcodeFieldLength,
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Grid>
                        </Grid>
                        <div className="updateBtn" style={{ width: '840px' }}>
                            <button className='merchant-update-button' type="submit" disabled={!isChanged}>Update Details</button>
                        </div>
                    </Row>
                </LocalForm>
            </div>
        </div>
    )
}

export default MerchantProfile
